import { useMemo } from 'react';
import { differenceInDays } from 'date-fns';

import { useIndustryTimeseries } from '@/hooks/useIndustryTimeseries';
import { adjustMarketTimeseriesBackOneDay } from '../utils';

type Args = {
  market: string;
  periodStart: number;
  periodEnd: number;
  enabled?: boolean;
};

// TODO: This is pretty much casting to a Record<string, number> :(...
// At least the return type is inline with the legacy response type
// We need a better way to either check the type or, ideally, have the query return the correct type
const isRecord = (value: unknown): value is Record<string, number> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const useMarketPerformanceTimeseries = ({
  market,
  periodStart,
  periodEnd,
  enabled = true,
}: Args) => {
  const { data, status } = useIndustryTimeseries({
    market,
    industry: 0,
    startUnix: periodStart,
    endUnix: periodEnd,
    points: differenceInDays(periodEnd, periodStart),
    enabled,
  });
  // Adjust market data backwards by 1 day. See detailed explanation in function definition
  const adjustedMarketTimeseries = useMemo(
    () =>
      adjustMarketTimeseriesBackOneDay(
        isRecord(data?.marketCap) ? data.marketCap : {}
      ),
    [data?.marketCap]
  );
  return {
    data: adjustedMarketTimeseries,
    status,
  };
};
